// 최근 본 상품 관리 유틸리티
export class RecentProductsManager {
    constructor() {
        this.storageKey = 'recent_products';
        this.maxItems = 10; // 최대 10개까지 저장
    }

    // 최근 본 상품 목록 가져오기
    getRecentProducts() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('최근 본 상품 불러오기 실패:', error);
            return [];
        }
    }

    // 상품을 최근 본 상품에 추가
    addProduct(product) {
        try {
            const recentProducts = this.getRecentProducts();

            // 중복 제거 (같은 ID의 상품이 있으면 제거)
            const filteredProducts = recentProducts.filter(item => item.id !== product.id);

            // 새 상품을 맨 앞에 추가
            const newProduct = {
                id: product.id,
                name: product.name,
                image: product.image || product.mainImageUrl,
                price: product.price,
                salePrice: product.salePrice,
                discountRate: product.discountRate,
                addedAt: new Date().toISOString()
            };

            filteredProducts.unshift(newProduct);

            // 최대 개수 제한
            const limitedProducts = filteredProducts.slice(0, this.maxItems);

            // 로컬스토리지에 저장
            localStorage.setItem(this.storageKey, JSON.stringify(limitedProducts));

            console.log('최근 본 상품에 추가:', newProduct.name);

            // 이벤트 발생 (다른 컴포넌트에서 감지할 수 있도록)
            window.dispatchEvent(new CustomEvent('recent-products-updated', {
                detail: { products: limitedProducts }
            }));

        } catch (error) {
            console.error('최근 본 상품 추가 실패:', error);
        }
    }

    // 특정 상품 제거
    removeProduct(productId) {
        try {
            const recentProducts = this.getRecentProducts();
            const filteredProducts = recentProducts.filter(item => item.id !== productId);

            localStorage.setItem(this.storageKey, JSON.stringify(filteredProducts));

            // 이벤트 발생
            window.dispatchEvent(new CustomEvent('recent-products-updated', {
                detail: { products: filteredProducts }
            }));

        } catch (error) {
            console.error('최근 본 상품 제거 실패:', error);
        }
    }

    // 전체 삭제
    clearAll() {
        try {
            localStorage.removeItem(this.storageKey);

            // 이벤트 발생
            window.dispatchEvent(new CustomEvent('recent-products-updated', {
                detail: { products: [] }
            }));

        } catch (error) {
            console.error('최근 본 상품 전체 삭제 실패:', error);
        }
    }
}

// 싱글톤 인스턴스 생성
export const recentProductsManager = new RecentProductsManager();